/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { AxiosRequestConfig } from "axios";

//custom libraries
import {
  METHOD,
  ONLINE_STORE,
  ONLINE_STORE_DESCRIPTIONS,
} from "../../constants/requests";
import { useRestService } from "./use-rest-service";

export const useOnlineStoreResource = () => {
  const { executeV2Request } = useRestService();

  const getOnlineStoreForCsr = () => {
    const requestOptions: AxiosRequestConfig = {
      method: METHOD.GET,
      url: ONLINE_STORE,
      params: {
        usage: "HCL_UserTool",
      },
    };

    return executeV2Request(requestOptions);
  };

  const getOnlineStoreDescription = (id: string) => {
    const requestOptions: AxiosRequestConfig = {
      method: METHOD.GET,
      url: ONLINE_STORE_DESCRIPTIONS.replace("{id}", id),
      params: {
        usage: "HCL_UserTool",
        //dataLanguageIds need to pass in even it is empty to avoid server error
        dataLanguageIds: "",
      },
    };

    return executeV2Request(requestOptions);
  };

  return {
    getOnlineStoreForCsr,
    getOnlineStoreDescription,
  };
};
